// export const Base = "https://aqlli-uy.uz/";
export const Base = "https://server.ddparfum.uz/";
export const BaseUrl = Base + "api/v1";
